import React from 'react';
import FormButton from '@app/component/form/button/FormButton';
import { useIntercom } from 'react-use-intercom';
import SecurityService from '@app/model/_security/service/SecurityService';
import { useNavigate } from 'react-router-dom';


const ErrorPageAccessDenied = React.memo(() => {

	const intercom = useIntercom();
	const navigate = useNavigate();

	const clearTokenStateAndGotoSignIn = () => {
		SecurityService.removeToken();
		navigate('/sign-in');
	}

	return <div className="min-h-full bg-white py-16 px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
		<div className="mx-auto max-w-max">
			<main className="sm:flex">
				<p className="text-4xl font-bold tracking-tight text-blue-600 sm:text-8xl">403</p>
				<div className="sm:ml-6">
					<div className="sm:border-l sm:border-slate-200 sm:pl-6">
						<h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Access Denied</h1>
						<p className="mt-1 text-base text-slate-500">
							You do not have access to perform this operation.
						</p>
					</div>
					<div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
						<FormButton onClick={clearTokenStateAndGotoSignIn} state="primary">
							Clear Session & Sign In
						</FormButton>
						<FormButton state="white" onClick={() => intercom.show()}>
							Contact support
						</FormButton>
					</div>
				</div>
			</main>
		</div>
	</div>;
});

export default ErrorPageAccessDenied;